import { render } from "./CountryTable.vue?vue&type=template&id=58469648&scoped=true"
import script from "./CountryTable.vue?vue&type=script&lang=js"
export * from "./CountryTable.vue?vue&type=script&lang=js"

import "./CountryTable.vue?vue&type=style&index=0&id=58469648&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58469648"]])

export default __exports__